/**
 * Obtiene el emoji de la bandera correspondiente al código de idioma
 * @param lang Código de idioma (es, en, etc.)
 * @returns Emoji de la bandera
 */
export const getFlagEmoji = (langCode: string): string => {
  // Manejar códigos de idioma con formato en-US o en-GB
  if (langCode.includes('-')) {
    const countryCode = langCode.split('-')[1].toUpperCase();
    const codePoints = countryCode.split('').map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }

  // Manejar códigos de idioma simples (es, en, etc.)
  const codePoints = langCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};
